import { AjusteCellRenderer } from "../../../../../../../shared/components/CustomCells/AjusteCellrenderer";
import { ColumnsFactory } from "../../../../../../../shared/components/Grid/functions";

export const getColumnDefs = (translate) => {
  return [
    ColumnsFactory.BooleanColumn('Ajuste',"ajuste",{pinned:'left', cellRendererFramework:AjusteCellRenderer}),
    ColumnsFactory.TextColumn(translate('tipo'), "tipo",{pinned:'left'}),
    ColumnsFactory.TextColumn(translate('nombre'), "nombre",{pinned:'left'}),
    ColumnsFactory.TextColumn("Cod DN/SG", "idDN",{pinned:'left'}),
    ColumnsFactory.TextColumn("DN/SG", "direccionNegocio"),
    ColumnsFactory.TextColumn(translate('centro-costo-destino-abreviado'), "centroCostoDestino"),
    ColumnsFactory.NumericColumn(translate('mes'), "mes"),
    ColumnsFactory.TextColumn("Nº Factura", "idFactura"),
    ColumnsFactory.DateColumn("Fecha Factura", "fechaFactura"),
    ColumnsFactory.TextColumn(translate('filial'), "sociedad"),
    ColumnsFactory.DecimalColumn(translate('salario'), "salario"),
    ColumnsFactory.DecimalColumn(translate('finiquito'), "finiquito"),
    ColumnsFactory.DecimalColumn(translate('prima'), "prima"),
    ColumnsFactory.DecimalColumn(translate('indemnizacion'), "indemnizacion"),
    ColumnsFactory.DecimalColumn("Costo Salarial", "costoSalarial"),
    ColumnsFactory.DecimalColumn(translate('ss-empresa'), "costo_SS"),
    ColumnsFactory.DecimalColumn("Ret.Esp", "ret_Hipot"),
    ColumnsFactory.DecimalColumn("Ret.Irpf", "irpf"),
    ColumnsFactory.DecimalColumn("Total Factura", "totalFactura")
  ];
};
